// @ts-nocheck
export const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 56 57"
      fill="none"
    >
      <g filter="url(#filter0_d_565_635)">
        <rect
          x="18"
          y="18.5"
          width="20"
          height="20"
          rx="10"
          fill="white"
          shapeRendering="crispEdges"
        />
        <rect
          x="18.2941"
          y="18.7941"
          width="19.4118"
          height="19.4118"
          rx="9.70588"
          stroke="white"
          strokeWidth="0.588235"
          shapeRendering="crispEdges"
        />
        <path
          d="M28.1111 33.7941V28.2385C28.1111 27.7147 28.1111 27.4529 27.9483 27.2901C27.7857 27.1274 27.5238 27.1274 27 27.1274"
          stroke="#D175B6"
          strokeWidth="1.66674"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 23.7941H28.01"
          stroke="#D175B6"
          strokeWidth="2.22232"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const PersonIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.7701 20.6421C6.88374 21.7653 1.93782 24.0588 4.95022 26.9288C6.42175 28.3307 8.06066 29.3333 10.1212 29.3333H21.8788C23.9393 29.3333 25.5783 28.3307 27.0497 26.9288C30.0621 24.0588 25.1163 21.7653 23.2299 20.6421C18.8064 18.0081 13.1936 18.0081 8.7701 20.6421Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 8.66663C22 11.9803 19.3137 14.6666 16 14.6666C12.6863 14.6666 10 11.9803 10 8.66663C10 5.35292 12.6863 2.66663 16 2.66663C19.3137 2.66663 22 5.35292 22 8.66663Z"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 2.66663V5.33329M8 2.66663V5.33329"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9943 17.3333H16.0063M15.9943 22.6666H16.0063M21.3217 17.3333H21.3337M10.667 17.3333H10.679M10.667 22.6666H10.679"
        stroke="white"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66699 10.6666H27.3337"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33301 16.3242C3.33301 10.5145 3.33301 7.60965 5.0025 5.80479C6.67199 3.99994 9.35899 3.99994 14.733 3.99994H17.2663C22.6403 3.99994 25.3274 3.99994 26.9969 5.80479C28.6663 7.60965 28.6663 10.5145 28.6663 16.3242V17.009C28.6663 22.8187 28.6663 25.7235 26.9969 27.5285C25.3274 29.3333 22.6403 29.3333 17.2663 29.3333H14.733C9.35899 29.3333 6.67199 29.3333 5.0025 27.5285C3.33301 25.7235 3.33301 22.8187 3.33301 17.009V16.3242Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10.6666H28"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0003 29.3333C8.63647 29.3333 2.66699 23.3637 2.66699 16C2.66699 8.63616 8.63653 2.66663 16.0003 2.66663C21.9705 2.66663 26.9679 6.59048 28.667 12H25.3337"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.6666V16L18.6667 18.6666"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2735 17.3333C29.3131 16.8945 29.3333 16.4497 29.3333 15.9999M20 29.3333C20.4555 29.1834 20.9004 29.0085 21.3333 28.8103M27.7208 22.6666C27.978 22.1711 28.2073 21.6577 28.4067 21.1282M24.2567 26.9722C24.7159 26.5921 25.1508 26.181 25.5584 25.7419"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2158 16.0708C20.2158 18.3988 18.3278 20.2855 15.9998 20.2855C13.6718 20.2855 11.7852 18.3988 11.7852 16.0708C11.7852 13.7415 13.6718 11.8548 15.9998 11.8548C18.3278 11.8548 20.2158 13.7415 20.2158 16.0708Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9977 25.8065C21.075 25.8065 25.719 22.1559 28.3337 16.0705C25.719 9.9852 21.075 6.33453 15.9977 6.33453H16.003C10.9257 6.33453 6.28166 9.9852 3.66699 16.0705C6.28166 22.1559 10.9257 25.8065 16.003 25.8065H15.9977Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.5 17.5L22 22"
        stroke="#D175B6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
        stroke="#D175B6"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ContractorSignupStep2Svg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M14.6754 28H12.8074C8.02703 28 5.63687 28 4.1518 26.4867C2.66675 24.9735 2.66675 22.5379 2.66675 17.6667C2.66675 12.7955 2.66675 10.3599 4.1518 8.84662C5.63687 7.33334 8.02703 7.33334 12.8074 7.33334H17.8777C22.6579 7.33334 25.0482 7.33334 26.5333 8.84662C27.6758 10.0109 27.9393 11.7212 28.0001 14.6667"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1333 25.1333L23.3333 23.9333V20.9333M17.3333 23.3333C17.3333 26.6471 20.0195 29.3333 23.3333 29.3333C26.647 29.3333 29.3333 26.6471 29.3333 23.3333C29.3333 20.0196 26.647 17.3333 23.3333 17.3333C20.0195 17.3333 17.3333 20.0196 17.3333 23.3333Z"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 7.33333L21.2009 6.92125C20.5407 4.86785 20.2107 3.84116 19.4251 3.2539C18.6394 2.66666 17.5959 2.66666 15.5087 2.66666H15.1578C13.0706 2.66666 12.0271 2.66666 11.2414 3.2539C10.4557 3.84116 10.1257 4.86785 9.46571 6.92125L9.33325 7.33333"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DocumentSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M19.9739 9.35416C19.9739 9.35416 20.6405 10.0208 21.3072 11.3542C21.3072 11.3542 23.4248 8.02082 25.3072 7.35416"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3265 2.69521C9.99526 2.55416 7.42158 2.93792 7.42158 2.93792C5.79644 3.05412 2.68203 3.96521 2.68205 9.28613C2.68208 14.5619 2.6476 21.0657 2.68205 23.6587C2.68205 25.2427 3.66288 28.9379 7.05776 29.1359C11.1842 29.3765 18.617 29.4277 22.0274 29.1359C22.9402 29.0844 25.9795 28.3677 26.3642 25.0609C26.7627 21.6352 26.6834 19.2543 26.6834 18.6876"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3333 9.35416C29.3333 13.0361 26.3456 16.0208 22.6601 16.0208C18.9748 16.0208 15.9871 13.0361 15.9871 9.35416C15.9871 5.67227 18.9748 2.68749 22.6601 2.68749C26.3456 2.68749 29.3333 5.67227 29.3333 9.35416Z"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.30737 17.3541H14.6407"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.30737 22.6875H19.9741"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Calendar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M24 2.66666V5.33333M8 2.66666V5.33333"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10.6667H28"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33325 16.3243C3.33325 10.5146 3.33325 7.60971 5.00275 5.80485C6.67224 4 9.35924 4 14.7333 4H17.2666C22.6406 4 25.3277 4 26.9971 5.80485C28.6666 7.60971 28.6666 10.5146 28.6666 16.3243V17.0091C28.6666 22.8188 28.6666 25.7236 26.9971 27.5285C25.3277 29.3333 22.6406 29.3333 17.2666 29.3333H14.7333C9.35924 29.3333 6.67224 29.3333 5.00275 27.5285C3.33325 25.7236 3.33325 22.8188 3.33325 17.0091V16.3243Z"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8062 16.0073L17.6274 17.6633C17.7394 17.8939 18.0381 18.1149 18.2899 18.1573L19.7785 18.4067C20.7303 18.5667 20.9543 19.2629 20.2685 19.9499L19.1113 21.1165C18.9153 21.3141 18.8079 21.6953 18.8686 21.9681L19.1999 23.4125C19.4613 24.5557 18.8593 24.998 17.8561 24.4005L16.4609 23.5677C16.2089 23.4172 15.7937 23.4172 15.537 23.5677L14.1418 24.4005C13.1432 24.998 12.5366 24.5511 12.7979 23.4125L13.1292 21.9681C13.1899 21.6953 13.0826 21.3141 12.8866 21.1165L11.7294 19.9499C11.0481 19.2629 11.2674 18.5667 12.2193 18.4067L13.7078 18.1573C13.9551 18.1149 14.2538 17.8939 14.3658 17.6633L15.187 16.0073C15.635 15.1087 16.3629 15.1087 16.8062 16.0073Z"
        stroke="#D175B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Idea = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
    >
      <path
        d="M10.1488 25.4983C9.51812 24.0807 9.1665 22.5035 9.1665 20.8415C9.1665 14.6689 14.0168 9.66504 19.9998 9.66504C25.983 9.66504 30.8332 14.6689 30.8332 20.8415C30.8332 22.5035 30.4815 24.0807 29.8508 25.4983"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M20 3.83167V5.49833"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6667 20.4984H35"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00016 20.4984H3.3335"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.784 8.71289L30.6055 9.89141"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.39483 9.89299L8.21631 8.71448"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1948 32.6759C25.8788 32.131 26.5542 30.5897 26.7442 29.0393C26.8008 28.5763 26.4198 28.192 25.9532 28.192L14.1279 28.1924C13.6453 28.1925 13.2576 28.602 13.3153 29.0813C13.5013 30.6285 13.971 31.7589 15.7556 32.6759M24.1948 32.6759C24.1948 32.6759 16.0494 32.6759 15.7556 32.6759M24.1948 32.6759C23.9923 35.9175 23.0562 37.2012 20.0112 37.1652C16.7542 37.2253 16.0049 35.6385 15.7556 32.6759"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GroupChat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.774 18C21.5233 18 22.1193 17.5285 22.6545 16.8691C23.7499 15.5194 21.9513 14.4408 21.2654 13.9126C20.568 13.3756 19.7894 13.0714 19 13M18 11C19.3807 11 20.5 9.88071 20.5 8.5C20.5 7.11929 19.3807 6 18 6"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3.22596 18C2.47666 18 1.88067 17.5285 1.34555 16.8691C0.250087 15.5194 2.04867 14.4408 2.73465 13.9126C3.43197 13.3756 4.21058 13.0714 5 13M5.5 11C4.11929 11 3 9.88071 3 8.5C3 7.11929 4.11929 6 5.5 6"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.0838 15.1112C7.06203 15.743 4.38299 17.0331 6.0147 18.6474C6.81178 19.436 7.69952 20 8.81563 20H15.1844C16.3005 20 17.1882 19.436 17.9853 18.6474C19.617 17.0331 16.938 15.743 15.9162 15.1112C13.5201 13.6296 10.4799 13.6296 8.0838 15.1112Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.7998 18.3C10.7998 17.9022 10.9578 17.5206 11.2391 17.2393C11.5204 16.958 11.902 16.8 12.2998 16.8C12.6976 16.8 13.0792 16.958 13.3605 17.2393C13.6418 17.5206 13.7998 17.9022 13.7998 18.3C13.7998 18.6978 13.6418 19.0793 13.3605 19.3607C13.0792 19.642 12.6976 19.8 12.2998 19.8C11.902 19.8 11.5204 19.642 11.2391 19.3607C10.9578 19.0793 10.7998 18.6978 10.7998 18.3ZM10.7998 12.3C10.7998 11.9022 10.9578 11.5206 11.2391 11.2393C11.5204 10.958 11.902 10.8 12.2998 10.8C12.6976 10.8 13.0792 10.958 13.3605 11.2393C13.6418 11.5206 13.7998 11.9022 13.7998 12.3C13.7998 12.6978 13.6418 13.0793 13.3605 13.3606C13.0792 13.642 12.6976 13.8 12.2998 13.8C11.902 13.8 11.5204 13.642 11.2391 13.3606C10.9578 13.0793 10.7998 12.6978 10.7998 12.3ZM10.7998 6.29999C10.7998 5.90216 10.9578 5.52063 11.2391 5.23933C11.5204 4.95802 11.902 4.79999 12.2998 4.79999C12.6976 4.79999 13.0792 4.95802 13.3605 5.23933C13.6418 5.52063 13.7998 5.90216 13.7998 6.29999C13.7998 6.69781 13.6418 7.07934 13.3605 7.36065C13.0792 7.64195 12.6976 7.79999 12.2998 7.79999C11.902 7.79999 11.5204 7.64195 11.2391 7.36065C10.9578 7.07934 10.7998 6.69781 10.7998 6.29999Z"
        fill="white"
      />
    </svg>
  );
};

export const SendMessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M17.369 0.654259C17.1792 0.465833 16.9412 0.33337 16.681 0.271428C16.4209 0.209487 16.1487 0.220464 15.8944 0.303154L1.21816 5.19857C0.945976 5.28481 0.705453 5.44979 0.526973 5.67265C0.348493 5.89552 0.240061 6.16628 0.215372 6.45073C0.190684 6.73518 0.250846 7.02058 0.388261 7.27086C0.525675 7.52114 0.734179 7.72509 0.987436 7.85694L7.07661 10.8664L10.0861 16.9756C10.207 17.2148 10.3921 17.4155 10.6207 17.5555C10.8492 17.6955 11.1122 17.7691 11.3802 17.7681H11.4805C11.7675 17.747 12.0415 17.64 12.2669 17.4611C12.4923 17.2822 12.6587 17.0397 12.7445 16.765L17.7101 2.1289C17.7988 1.87604 17.8138 1.60319 17.7534 1.34212C17.693 1.08105 17.5597 0.842509 17.369 0.654259ZM1.84012 6.58293L14.6505 2.30947L7.53806 9.42186L1.84012 6.58293ZM11.4504 16.1832L8.60141 10.4852L15.7138 3.37282L11.4504 16.1832Z"
        fill="white"
      />
    </svg>
  );
};

export const NotificationIcon = ({ style = {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      style={style}
    >
      <path
        d="M6.87783 15.3213C6.77985 17.1826 6.89248 19.164 5.22951 20.4112C4.45552 20.9917 4 21.9026 4 22.8702C4 24.201 5.0424 25.3333 6.4 25.3333H25.6C26.9576 25.3333 28 24.201 28 22.8702C28 21.9026 27.5445 20.9917 26.7705 20.4112C25.1075 19.164 25.2201 17.1826 25.1221 15.3213C24.8668 10.4696 20.8584 6.66663 16 6.66663C11.1416 6.66663 7.13317 10.4696 6.87783 15.3213Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 4.16663C14 5.2712 14.8955 6.66663 16 6.66663C17.1045 6.66663 18 5.2712 18 4.16663C18 3.06205 17.1045 2.66663 16 2.66663C14.8955 2.66663 14 3.06205 14 4.16663Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M20 25.3333C20 27.5425 18.2092 29.3333 16 29.3333C13.7908 29.3333 12 27.5425 12 25.3333"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EventNoteIcon = () => {
  return (
    <svg
      width="40"
      height="35"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="white"></rect>
      <path
        d="M18.2892 29.9614H17.3911C14.1426 29.9614 12.5184 29.9614 11.5092 28.9363C10.5 27.9111 10.5 26.2612 10.5 22.9614V17.9614C10.5 14.6616 10.5 13.0117 11.5092 11.9866C12.5184 10.9614 14.1426 10.9614 17.3911 10.9614H20.3444C23.5929 10.9614 25.4907 11.0166 26.5 12.0417C27.5092 13.0669 27.5 14.6616 27.5 17.9614V19.1478"
        stroke="#060606"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M23.9453 10V12M18.9453 10V12M13.9453 10V12"
        stroke="#060606"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15 23H19M15 18H23"
        stroke="#060606"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        opacity="0.93"
        d="M28.7598 22.8785C27.8544 21.8641 27.3112 21.9245 26.7076 22.1056C26.2851 22.166 24.8365 23.8568 24.2329 24.3952C23.2419 25.3743 22.2464 26.3823 22.1807 26.5138C21.9931 26.8188 21.8186 27.3592 21.7341 27.963C21.5771 28.8688 21.3507 29.8885 21.6375 29.9759C21.9242 30.0632 22.7239 29.8954 23.6293 29.7625C24.2329 29.6538 24.6554 29.533 24.9572 29.3519C25.3797 29.0983 26.1644 28.2046 27.5164 26.8761C28.3644 25.9833 29.1823 25.3664 29.4238 24.7626C29.6652 23.8568 29.3031 23.3737 28.7598 22.8785Z"
        stroke="#060606"
        strokeWidth="1.5"
      ></path>
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.6665 5L7.42735 8.26414C9.55117 9.4675 10.4485 9.4675 12.5723 8.26414L18.3332 5"
        stroke="white"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M1.67965 11.2296C1.73412 13.7843 1.76136 15.0615 2.70397 16.0078C3.64657 16.954 4.95845 16.9869 7.5822 17.0528C9.19925 17.0935 10.8004 17.0935 12.4175 17.0528C15.0413 16.9869 16.3531 16.954 17.2958 16.0078C18.2383 15.0615 18.2656 13.7843 18.32 11.2296C18.3376 10.4082 18.3376 9.59171 18.32 8.77029C18.2656 6.21568 18.2383 4.93837 17.2958 3.99218C16.3531 3.04599 15.0413 3.01303 12.4175 2.9471C10.8004 2.90647 9.19925 2.90647 7.58219 2.94709C4.95845 3.01301 3.64657 3.04597 2.70396 3.99217C1.76135 4.93836 1.73412 6.21567 1.67964 8.77029C1.66212 9.59171 1.66213 10.4082 1.67965 11.2296Z"
        stroke="white"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SmallEyeIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2867 9.20413C18.54 9.55938 18.6667 9.73704 18.6667 9.99996C18.6667 10.2629 18.54 10.4405 18.2867 10.7958C17.1483 12.3921 14.241 15.8333 10.3333 15.8333C6.42565 15.8333 3.51842 12.3921 2.38003 10.7958C2.12667 10.4405 2 10.2629 2 9.99996C2 9.73704 2.12667 9.55938 2.38003 9.20413C3.51842 7.60783 6.42565 4.16663 10.3333 4.16663C14.241 4.16663 17.1483 7.60783 18.2867 9.20413Z"
        stroke="white"
        strokeWidth="1.25"
      />
      <path
        d="M12.8335 10C12.8335 8.61925 11.7142 7.5 10.3335 7.5C8.95275 7.5 7.8335 8.61925 7.8335 10C7.8335 11.3807 8.95275 12.5 10.3335 12.5C11.7142 12.5 12.8335 11.3807 12.8335 10Z"
        stroke="white"
        strokeWidth="1.25"
      />
    </svg>
  );
};

export const SendMsg = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="#D175B6" />
      <path
        d="M19.9854 23.4083L23.2268 27.0936C24.4277 28.4589 25.0282 29.1416 25.6567 28.9754C26.2852 28.8092 26.5008 27.9108 26.9318 26.1138L29.3229 16.1459C29.9868 13.3783 30.3187 11.9945 29.5808 11.312C28.843 10.6295 27.564 11.1372 25.0061 12.1528L13.1388 16.8645C11.0929 17.6767 10.07 18.0829 10.0051 18.7808C9.99842 18.8522 9.99831 18.9241 10.0047 18.9955C10.0675 19.6937 11.0892 20.1033 13.1326 20.9223C14.0584 21.2934 14.5213 21.479 14.8532 21.8344C14.8905 21.8743 14.9264 21.9157 14.9608 21.9584C15.2666 22.3384 15.3971 22.8371 15.6581 23.8344L16.1465 25.701C16.4005 26.6715 16.5275 27.1568 16.8601 27.223C17.1927 27.2891 17.4823 26.8867 18.0614 26.0819L19.9854 23.4083ZM19.9854 23.4083L19.6676 23.0771C19.3059 22.7001 19.1251 22.5117 19.1251 22.2775C19.1251 22.0433 19.3059 21.8548 19.6676 21.4778L23.2406 17.7541"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FauserPlus = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#D175B6" />
      <path
        d="M18 12.5C18 9.73858 15.7614 7.5 13 7.5C10.2386 7.5 8 9.73858 8 12.5C8 15.2614 10.2386 17.5 13 17.5C15.7614 17.5 18 15.2614 18 12.5Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 24.5C20 20.634 16.866 17.5 13 17.5C9.13401 17.5 6 20.634 6 24.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 16.3929C20 16.3929 21.2 17.0447 21.8 18C21.8 18 23.6 14.25 26 13"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Fauser = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="white" />
      <path
        d="M18 11.5C18 13.433 16.433 15 14.5 15C12.567 15 11 13.433 11 11.5C11 9.567 12.567 8 14.5 8C16.433 8 18 9.567 18 11.5Z"
        stroke="#D175B6"
        strokeWidth="1.5"
      />
      <path
        d="M19.1429 24H9.85714C8.83147 24 8 23.2325 8 22.2857C8 19.9188 10.0787 18 12.6429 18H16.3571C17.4023 18 18.3669 18.3188 19.1429 18.8568"
        stroke="#D175B6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 18V24M26 21H20"
        stroke="#D175B6"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CancelCircle = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9992 20L12 12M12.0009 20L20 12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3332 16C29.3332 8.63616 23.3636 2.66663 15.9998 2.66663C8.63604 2.66663 2.6665 8.63616 2.6665 16C2.6665 23.3637 8.63604 29.3333 15.9998 29.3333C23.3636 29.3333 29.3332 23.3637 29.3332 16Z"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
};

export const Check = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="20"
        height="20"
        rx="10"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M5.6665 12.6667C5.6665 12.6667 7.79984 13.8834 8.8665 15.6667C8.8665 15.6667 12.0665 8.66671 16.3332 6.33337"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckBg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#D175B6" />
      <path
        d="M4.6665 11.6667C4.6665 11.6667 6.79984 12.8834 7.8665 14.6667C7.8665 14.6667 11.0665 7.66671 15.3332 5.33337"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EventNotesNotification = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7191 29.2819H12.5216C8.19031 29.2819 6.02464 29.2819 4.67907 27.9151C3.3335 26.5481 3.3335 24.3483 3.3335 19.9485V13.2819C3.3335 8.88209 3.3335 6.68221 4.67907 5.31539C6.02464 3.94855 8.19031 3.94855 12.5216 3.94855H16.4594C20.7907 3.94855 23.3211 4.02212 24.6668 5.38896C26.0124 6.75579 26.0002 8.88209 26.0002 13.2819V14.8637"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2606 2.66669V5.33335M14.5939 2.66669V5.33335M7.92725 2.66669V5.33335"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3335 20H14.6668M9.3335 13.3333H20.0002"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        opacity="0.93"
        d="M27.6798 19.838C26.4726 18.4855 25.7483 18.566 24.9435 18.8075C24.3802 18.888 22.4487 21.1424 21.6439 21.8603C20.3226 23.1657 18.9952 24.5097 18.9076 24.6851C18.6575 25.0917 18.4248 25.8123 18.3122 26.6173C18.1028 27.8251 17.801 29.1847 18.1834 29.3012C18.5656 29.4176 19.6319 29.1939 20.8391 29.0167C21.6439 28.8717 22.2072 28.7107 22.6096 28.4692C23.173 28.1311 24.2192 26.9395 26.0219 25.1681C27.1526 23.9777 28.2431 23.1552 28.5651 22.3501C28.887 21.1424 28.4042 20.4983 27.6798 19.838Z"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
};

export const ExpandCollapseIcon = ({
  size = 97,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 97 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_359_1874)">
        <rect
          x="30.3215"
          y="30.3213"
          width="36"
          height="36"
          rx="18"
          fill="black"
        />
        <rect
          x="30.3215"
          y="30.3213"
          width="36"
          height="36"
          rx="18"
          stroke="#D175B6"
          strokeWidth="0.642857"
        />
        <path
          d="M50.3125 43.6514C50.4625 43.5007 50.4627 43.259 50.3125 43.1084H50.3115C50.2411 43.0377 50.144 42.9971 50.042 42.9971C49.9656 42.9971 49.8918 43.0194 49.8301 43.0605L49.7725 43.1084L44.832 48.0498L44.8311 48.0508C44.6808 48.2009 44.6808 48.4417 44.8311 48.5918L44.832 48.5928L49.7725 53.5342C49.8432 53.6051 49.9401 53.6455 50.042 53.6455C50.1439 53.6455 50.2417 53.6051 50.3125 53.5342C50.4627 53.3835 50.4626 53.1418 50.3125 52.9912L45.9541 48.6338L45.6416 48.3223L50.3125 43.6514Z"
          fill="white"
          stroke="white"
          strokeWidth="0.88261"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_359_1874"
          x="-3.8147e-06"
          y="-3.8147e-06"
          width="96.6431"
          height="96.6426"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.819608 0 0 0 0 0.458824 0 0 0 0 0.713726 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_359_1874"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_359_1874"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const HomeIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 0.5C12.6222 0.5 13.2275 0.705057 13.7217 1.08301L22.3877 7.70996C22.7334 7.97436 23.0141 8.3149 23.207 8.70508C23.3999 9.09535 23.4999 9.5256 23.5 9.96094V20.6426C23.4999 21.394 23.2013 22.1152 22.6699 22.6465C22.1386 23.1777 21.4174 23.4756 20.666 23.4756H3.33398C2.58262 23.4756 1.86144 23.1777 1.33008 22.6465C0.798706 22.1152 0.500113 21.394 0.5 20.6426V9.96094C0.5 9.07874 0.911464 8.2459 1.6123 7.70996L10.2783 1.08301C10.7725 0.705057 11.3778 0.5 12 0.5ZM12 0.833008C11.451 0.833008 10.9175 1.01415 10.4814 1.34766L1.81445 7.97461C1.50937 8.20795 1.26196 8.50918 1.0918 8.85352C0.921783 9.19774 0.834011 9.57701 0.833984 9.96094V20.6426C0.833984 21.3056 1.09659 21.9423 1.56543 22.4111C2.03427 22.88 2.67094 23.1426 3.33398 23.1426H20.666C21.3291 23.1426 21.9657 22.88 22.4346 22.4111C22.9034 21.9423 23.166 21.3056 23.166 20.6426V9.96094C23.166 9.57701 23.0782 9.19774 22.9082 8.85352C22.738 8.50918 22.4906 8.20795 22.1855 7.97461L13.5186 1.34766C13.0825 1.01415 12.549 0.833008 12 0.833008Z"
        stroke={strokeColor}
      />
      <path
        d="M9.3335 14.4766H14.6665C15.0643 14.4766 15.4457 14.6347 15.7271 14.916C16.0084 15.1973 16.1665 15.5787 16.1665 15.9766V23.3105C16.1664 23.3545 16.1488 23.3966 16.1177 23.4277C16.0865 23.459 16.0437 23.4766 15.9995 23.4766C15.9555 23.4764 15.9134 23.4588 15.8823 23.4277C15.8512 23.3966 15.8336 23.3545 15.8335 23.3105V15.9766C15.8335 15.3322 15.3109 14.8106 14.6665 14.8105H9.3335C8.6891 14.8105 8.1665 15.3322 8.1665 15.9766V23.3105C8.16638 23.3545 8.14878 23.3966 8.11768 23.4277C8.08645 23.459 8.04367 23.4766 7.99951 23.4766C7.95553 23.4764 7.91343 23.4588 7.88232 23.4277C7.85121 23.3966 7.83362 23.3545 7.8335 23.3105V15.9766C7.8335 15.5787 7.99164 15.1973 8.27295 14.916C8.55425 14.6347 8.93567 14.4766 9.3335 14.4766Z"
        stroke={strokeColor}
      />
    </svg>
  );
};

export const DashboardIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 512 512"
      fill={strokeColor}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="path-1-inside-1_478_7078" fill={strokeColor}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.8923 0H68.9231C59.904 0 52.1452 1.58934e-07 45.2923 1.61465C34.6835 4.14944 24.9836 9.57155 17.2674 17.2802C9.5512 24.9889 4.11993 34.6831 1.57538 45.2888C-1.43051e-06 52.1412 0 59.86 0 68.9178V167.372C0 176.39 1.58946e-07 184.148 1.61477 191.001C4.14976 201.609 9.57229 211.308 17.2816 219.023C24.9908 226.739 34.6858 232.17 45.2923 234.714C52.1452 236.29 59.8646 236.29 68.9231 236.29H167.385C176.404 236.29 184.162 236.29 191.015 234.675C201.624 232.14 211.324 226.718 219.04 219.009C226.756 211.301 232.188 201.606 234.732 191.001C236.308 184.148 236.308 176.43 236.308 167.372V68.9178C236.308 59.8994 236.308 52.1412 234.693 45.2888C232.158 34.6808 226.735 24.9817 219.026 17.2661C211.317 9.55047 201.622 4.11961 191.015 1.57526C184.162 -1.4304e-06 176.443 0 167.385 0H70.8923ZM54.4689 39.9329C56.1625 39.5391 58.8012 39.3816 70.8923 39.3816H165.415C177.546 39.3816 180.145 39.4997 181.839 39.9329C185.377 40.7789 188.611 42.5882 191.183 45.1603C193.756 47.7323 195.565 50.9665 196.411 54.5041C196.805 56.1581 196.923 58.7573 196.923 70.8869V165.403C196.923 177.532 196.805 180.131 196.372 181.825C195.526 185.362 193.716 188.597 191.144 191.169C188.572 193.741 185.337 195.55 181.799 196.396C180.185 196.75 177.585 196.908 165.415 196.908H70.8923C58.7618 196.908 56.1625 196.79 54.4689 196.357C50.931 195.511 47.6966 193.701 45.1244 191.129C42.5521 188.557 40.7427 185.323 39.8966 181.785C39.5422 180.171 39.3846 177.572 39.3846 165.403V70.8869C39.3846 58.7573 39.5028 56.1581 39.936 54.4647C40.782 50.9271 42.5915 47.6929 45.1637 45.1209C47.736 42.5489 50.9704 40.7395 54.5083 39.8935L54.4689 39.9329ZM346.585 0H344.615C335.596 0 327.838 1.58934e-07 320.985 1.61465C310.376 4.14944 300.676 9.57155 292.96 17.2802C285.244 24.9889 279.812 34.6831 277.268 45.2888C275.692 52.1412 275.692 59.86 275.692 68.9178V167.372C275.692 176.39 275.692 184.148 277.307 191.001C279.842 201.609 285.265 211.308 292.974 219.023C300.683 226.739 310.378 232.17 320.985 234.714C327.838 236.29 335.557 236.29 344.615 236.29H443.077C452.096 236.29 459.855 236.29 466.708 234.675C477.317 232.14 487.016 226.718 494.733 219.009C502.449 211.301 507.88 201.606 510.425 191.001C512 184.148 512 176.43 512 167.372V68.9178C512 59.8994 512 52.1412 510.385 45.2888C507.85 34.6808 502.428 24.9817 494.718 17.2661C487.009 9.55047 477.314 4.11961 466.708 1.57526C459.855 -1.4304e-06 452.135 0 443.077 0H346.585ZM330.161 39.9329C331.855 39.5391 334.494 39.3816 346.585 39.3816H441.108C453.238 39.3816 455.838 39.4997 457.531 39.9329C461.069 40.7789 464.303 42.5882 466.876 45.1603C469.448 47.7323 471.257 50.9665 472.103 54.5041C472.497 56.1581 472.615 58.7573 472.615 70.8869V165.403C472.615 177.532 472.458 180.131 472.064 181.825C471.218 185.362 469.408 188.597 466.836 191.169C464.264 193.741 461.03 195.55 457.492 196.396C455.838 196.79 453.238 196.908 441.108 196.908H346.585C334.454 196.908 331.855 196.79 330.161 196.357C326.623 195.511 323.389 193.701 320.817 191.129C318.244 188.557 316.435 185.323 315.589 181.785C315.234 180.171 315.077 177.572 315.077 165.403V70.8869C315.077 58.7573 315.195 56.1581 315.628 54.4647C316.474 50.9271 318.284 47.6929 320.856 45.1209C323.428 42.5489 326.663 40.7395 330.201 39.8935L330.161 39.9329ZM68.9231 275.671H167.385C176.404 275.671 184.162 275.671 191.015 277.286C201.624 279.821 211.324 285.243 219.04 292.951C226.756 300.66 232.188 310.354 234.732 320.96C236.308 327.812 236.308 335.531 236.308 344.589V443.043C236.308 452.061 236.308 459.819 234.693 466.672C232.158 477.28 226.735 486.979 219.026 494.695C211.317 502.41 201.622 507.841 191.015 510.385C184.162 511.961 176.443 511.961 167.385 511.961H68.9231C59.904 511.961 52.1452 511.961 45.2923 510.346C34.6835 507.811 24.9836 502.389 17.2674 494.68C9.5512 486.972 4.11993 477.278 1.57538 466.672C-1.43051e-06 459.819 0 452.101 0 443.043V344.589C0 335.571 1.58946e-07 327.812 1.61477 320.96C4.14976 310.352 9.57229 300.653 17.2816 292.937C24.9908 285.222 34.6858 279.791 45.2923 277.246C52.1452 275.671 59.8646 275.671 68.9231 275.671ZM70.8923 315.053C58.7618 315.053 56.1625 315.171 54.4689 315.604C50.931 316.45 47.6966 318.259 45.1244 320.831C42.5521 323.403 40.7427 326.638 39.8966 330.175C39.5422 331.79 39.3846 334.389 39.3846 346.558V441.074C39.3846 453.203 39.5028 455.802 39.936 457.496C40.782 461.034 42.5915 464.268 45.1637 466.84C47.736 469.412 50.9704 471.221 54.5083 472.067C56.1625 472.461 58.7618 472.579 70.8923 472.579H165.415C177.546 472.579 180.145 472.422 181.839 472.028C185.377 471.182 188.611 469.372 191.183 466.8C193.756 464.228 195.565 460.994 196.411 457.457C196.805 455.803 196.923 453.203 196.923 441.074V346.558C196.923 334.428 196.805 331.829 196.372 330.136C195.526 326.598 193.716 323.364 191.144 320.792C188.572 318.22 185.337 316.411 181.799 315.565C180.185 315.21 177.585 315.053 165.415 315.053H70.8923ZM346.585 275.671H344.615C335.596 275.671 327.838 275.671 320.985 277.286C310.376 279.821 300.676 285.243 292.96 292.951C285.244 300.66 279.812 310.354 277.268 320.96C275.692 327.812 275.692 335.531 275.692 344.589V443.043C275.692 452.061 275.692 459.819 277.307 466.672C279.842 477.28 285.265 486.979 292.974 494.695C300.683 502.41 310.378 507.841 320.985 510.385C327.838 512 335.596 512 344.615 512H443.077C452.096 512 459.855 512 466.708 510.385C477.309 507.844 487.001 502.419 494.71 494.711C502.418 487.003 507.844 477.312 510.385 466.711C512 459.859 512 452.101 512 443.082V344.589C512 335.571 512 327.812 510.385 320.96C507.85 310.352 502.428 300.653 494.718 292.937C487.009 285.222 477.314 279.791 466.708 277.246C459.855 275.671 452.135 275.671 443.077 275.671H346.585ZM330.161 315.604C331.855 315.21 334.494 315.053 346.585 315.053H441.108C453.238 315.053 455.838 315.171 457.531 315.604C461.069 316.45 464.303 318.259 466.876 320.831C469.448 323.403 471.257 326.638 472.103 330.175C472.497 331.829 472.615 334.428 472.615 346.558V441.074C472.615 453.203 472.458 455.802 472.064 457.496C471.218 461.034 469.408 464.268 466.836 466.84C464.264 469.412 461.03 471.221 457.492 472.067C455.838 472.461 453.238 472.579 441.108 472.579H346.585C334.454 472.579 331.855 472.422 330.161 472.028C326.623 471.182 323.389 469.372 320.817 466.8C318.244 464.228 316.435 460.994 315.589 457.457C315.234 455.842 315.077 453.243 315.077 441.074V346.558C315.077 334.428 315.195 331.829 315.628 330.136C316.474 326.598 318.284 323.364 320.856 320.792C323.428 318.22 326.663 316.411 330.201 315.565L330.161 315.604Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.8923 0H68.9231C59.904 0 52.1452 1.58934e-07 45.2923 1.61465C34.6835 4.14944 24.9836 9.57155 17.2674 17.2802C9.5512 24.9889 4.11993 34.6831 1.57538 45.2888C-1.43051e-06 52.1412 0 59.86 0 68.9178V167.372C0 176.39 1.58946e-07 184.148 1.61477 191.001C4.14976 201.609 9.57229 211.308 17.2816 219.023C24.9908 226.739 34.6858 232.17 45.2923 234.714C52.1452 236.29 59.8646 236.29 68.9231 236.29H167.385C176.404 236.29 184.162 236.29 191.015 234.675C201.624 232.14 211.324 226.718 219.04 219.009C226.756 211.301 232.188 201.606 234.732 191.001C236.308 184.148 236.308 176.43 236.308 167.372V68.9178C236.308 59.8994 236.308 52.1412 234.693 45.2888C232.158 34.6808 226.735 24.9817 219.026 17.2661C211.317 9.55047 201.622 4.11961 191.015 1.57526C184.162 -1.4304e-06 176.443 0 167.385 0H70.8923ZM54.4689 39.9329C56.1625 39.5391 58.8012 39.3816 70.8923 39.3816H165.415C177.546 39.3816 180.145 39.4997 181.839 39.9329C185.377 40.7789 188.611 42.5882 191.183 45.1603C193.756 47.7323 195.565 50.9665 196.411 54.5041C196.805 56.1581 196.923 58.7573 196.923 70.8869V165.403C196.923 177.532 196.805 180.131 196.372 181.825C195.526 185.362 193.716 188.597 191.144 191.169C188.572 193.741 185.337 195.55 181.799 196.396C180.185 196.75 177.585 196.908 165.415 196.908H70.8923C58.7618 196.908 56.1625 196.79 54.4689 196.357C50.931 195.511 47.6966 193.701 45.1244 191.129C42.5521 188.557 40.7427 185.323 39.8966 181.785C39.5422 180.171 39.3846 177.572 39.3846 165.403V70.8869C39.3846 58.7573 39.5028 56.1581 39.936 54.4647C40.782 50.9271 42.5915 47.6929 45.1637 45.1209C47.736 42.5489 50.9704 40.7395 54.5083 39.8935L54.4689 39.9329ZM346.585 0H344.615C335.596 0 327.838 1.58934e-07 320.985 1.61465C310.376 4.14944 300.676 9.57155 292.96 17.2802C285.244 24.9889 279.812 34.6831 277.268 45.2888C275.692 52.1412 275.692 59.86 275.692 68.9178V167.372C275.692 176.39 275.692 184.148 277.307 191.001C279.842 201.609 285.265 211.308 292.974 219.023C300.683 226.739 310.378 232.17 320.985 234.714C327.838 236.29 335.557 236.29 344.615 236.29H443.077C452.096 236.29 459.855 236.29 466.708 234.675C477.317 232.14 487.016 226.718 494.733 219.009C502.449 211.301 507.88 201.606 510.425 191.001C512 184.148 512 176.43 512 167.372V68.9178C512 59.8994 512 52.1412 510.385 45.2888C507.85 34.6808 502.428 24.9817 494.718 17.2661C487.009 9.55047 477.314 4.11961 466.708 1.57526C459.855 -1.4304e-06 452.135 0 443.077 0H346.585ZM330.161 39.9329C331.855 39.5391 334.494 39.3816 346.585 39.3816H441.108C453.238 39.3816 455.838 39.4997 457.531 39.9329C461.069 40.7789 464.303 42.5882 466.876 45.1603C469.448 47.7323 471.257 50.9665 472.103 54.5041C472.497 56.1581 472.615 58.7573 472.615 70.8869V165.403C472.615 177.532 472.458 180.131 472.064 181.825C471.218 185.362 469.408 188.597 466.836 191.169C464.264 193.741 461.03 195.55 457.492 196.396C455.838 196.79 453.238 196.908 441.108 196.908H346.585C334.454 196.908 331.855 196.79 330.161 196.357C326.623 195.511 323.389 193.701 320.817 191.129C318.244 188.557 316.435 185.323 315.589 181.785C315.234 180.171 315.077 177.572 315.077 165.403V70.8869C315.077 58.7573 315.195 56.1581 315.628 54.4647C316.474 50.9271 318.284 47.6929 320.856 45.1209C323.428 42.5489 326.663 40.7395 330.201 39.8935L330.161 39.9329ZM68.9231 275.671H167.385C176.404 275.671 184.162 275.671 191.015 277.286C201.624 279.821 211.324 285.243 219.04 292.951C226.756 300.66 232.188 310.354 234.732 320.96C236.308 327.812 236.308 335.531 236.308 344.589V443.043C236.308 452.061 236.308 459.819 234.693 466.672C232.158 477.28 226.735 486.979 219.026 494.695C211.317 502.41 201.622 507.841 191.015 510.385C184.162 511.961 176.443 511.961 167.385 511.961H68.9231C59.904 511.961 52.1452 511.961 45.2923 510.346C34.6835 507.811 24.9836 502.389 17.2674 494.68C9.5512 486.972 4.11993 477.278 1.57538 466.672C-1.43051e-06 459.819 0 452.101 0 443.043V344.589C0 335.571 1.58946e-07 327.812 1.61477 320.96C4.14976 310.352 9.57229 300.653 17.2816 292.937C24.9908 285.222 34.6858 279.791 45.2923 277.246C52.1452 275.671 59.8646 275.671 68.9231 275.671ZM70.8923 315.053C58.7618 315.053 56.1625 315.171 54.4689 315.604C50.931 316.45 47.6966 318.259 45.1244 320.831C42.5521 323.403 40.7427 326.638 39.8966 330.175C39.5422 331.79 39.3846 334.389 39.3846 346.558V441.074C39.3846 453.203 39.5028 455.802 39.936 457.496C40.782 461.034 42.5915 464.268 45.1637 466.84C47.736 469.412 50.9704 471.221 54.5083 472.067C56.1625 472.461 58.7618 472.579 70.8923 472.579H165.415C177.546 472.579 180.145 472.422 181.839 472.028C185.377 471.182 188.611 469.372 191.183 466.8C193.756 464.228 195.565 460.994 196.411 457.457C196.805 455.803 196.923 453.203 196.923 441.074V346.558C196.923 334.428 196.805 331.829 196.372 330.136C195.526 326.598 193.716 323.364 191.144 320.792C188.572 318.22 185.337 316.411 181.799 315.565C180.185 315.21 177.585 315.053 165.415 315.053H70.8923ZM346.585 275.671H344.615C335.596 275.671 327.838 275.671 320.985 277.286C310.376 279.821 300.676 285.243 292.96 292.951C285.244 300.66 279.812 310.354 277.268 320.96C275.692 327.812 275.692 335.531 275.692 344.589V443.043C275.692 452.061 275.692 459.819 277.307 466.672C279.842 477.28 285.265 486.979 292.974 494.695C300.683 502.41 310.378 507.841 320.985 510.385C327.838 512 335.596 512 344.615 512H443.077C452.096 512 459.855 512 466.708 510.385C477.309 507.844 487.001 502.419 494.71 494.711C502.418 487.003 507.844 477.312 510.385 466.711C512 459.859 512 452.101 512 443.082V344.589C512 335.571 512 327.812 510.385 320.96C507.85 310.352 502.428 300.653 494.718 292.937C487.009 285.222 477.314 279.791 466.708 277.246C459.855 275.671 452.135 275.671 443.077 275.671H346.585ZM330.161 315.604C331.855 315.21 334.494 315.053 346.585 315.053H441.108C453.238 315.053 455.838 315.171 457.531 315.604C461.069 316.45 464.303 318.259 466.876 320.831C469.448 323.403 471.257 326.638 472.103 330.175C472.497 331.829 472.615 334.428 472.615 346.558V441.074C472.615 453.203 472.458 455.802 472.064 457.496C471.218 461.034 469.408 464.268 466.836 466.84C464.264 469.412 461.03 471.221 457.492 472.067C455.838 472.461 453.238 472.579 441.108 472.579H346.585C334.454 472.579 331.855 472.422 330.161 472.028C326.623 471.182 323.389 469.372 320.817 466.8C318.244 464.228 316.435 460.994 315.589 457.457C315.234 455.842 315.077 453.243 315.077 441.074V346.558C315.077 334.428 315.195 331.829 315.628 330.136C316.474 326.598 318.284 323.364 320.856 320.792C323.428 318.22 326.663 316.411 330.201 315.565L330.161 315.604Z"
        fill={strokeColor}
        stroke={strokeColor}
        strokeWidth="2"
        mask="url(#path-1-inside-1_478_7078)"
      />
    </svg>
  );
};

export const EventsIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M112 0C116.243 0 120.313 1.68571 123.314 4.68629C126.314 7.68687 128 11.7565 128 16V32H384V16C384 11.7565 385.686 7.68687 388.686 4.68629C391.687 1.68571 395.757 0 400 0C404.243 0 408.313 1.68571 411.314 4.68629C414.314 7.68687 416 11.7565 416 16V32H448C464.974 32 481.252 38.7428 493.255 50.7452C505.257 62.7475 512 79.0261 512 96V448C512 464.974 505.257 481.252 493.255 493.255C481.252 505.257 464.974 512 448 512H64C47.0261 512 30.7475 505.257 18.7452 493.255C6.74284 481.252 0 464.974 0 448V96C0 79.0261 6.74284 62.7475 18.7452 50.7452C30.7475 38.7428 47.0261 32 64 32H96V16C96 11.7565 97.6857 7.68687 100.686 4.68629C103.687 1.68571 107.757 0 112 0ZM64 64C55.5131 64 47.3737 67.3714 41.3726 73.3726C35.3714 79.3737 32 87.5131 32 96V128H480V96C480 87.5131 476.629 79.3737 470.627 73.3726C464.626 67.3714 456.487 64 448 64H64ZM480 160H32V448C32 456.487 35.3714 464.626 41.3726 470.627C47.3737 476.629 55.5131 480 64 480H448C456.487 480 464.626 476.629 470.627 470.627C476.629 464.626 480 456.487 480 448V160Z"
        fill={strokeColor}
      />
      <path
        d="M352 240C352 235.757 353.686 231.687 356.686 228.686C359.687 225.686 363.757 224 368 224H400C404.243 224 408.313 225.686 411.314 228.686C414.314 231.687 416 235.757 416 240V272C416 276.243 414.314 280.313 411.314 283.314C408.313 286.314 404.243 288 400 288H368C363.757 288 359.687 286.314 356.686 283.314C353.686 280.313 352 276.243 352 272V240Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export const LogisticsIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M127.999 256.25H384C393.969 256.25 402.035 264.317 402.035 274.286V292.821H457.143C463.166 292.821 468.803 295.833 472.149 300.853L508.721 355.71C510.693 358.669 511.75 362.156 511.75 365.714V457.143C511.75 467.112 503.683 475.179 493.714 475.179H453.597L453.538 475.345C445.999 496.489 425.981 511.75 402.285 511.75C378.589 511.75 358.573 496.489 351.034 475.345L350.976 475.179H270.739L270.681 475.345C263.142 496.489 243.124 511.75 219.428 511.75C195.732 511.75 175.716 496.489 168.177 475.345L168.118 475.179H127.999C118.03 475.178 109.964 467.112 109.964 457.143V274.286C109.964 264.317 118.03 256.25 127.999 256.25ZM219.428 438.607C209.201 438.608 200.893 446.915 200.893 457.143C200.893 467.37 209.201 475.678 219.428 475.679C229.655 475.679 237.964 467.37 237.964 457.143C237.964 446.915 229.655 438.607 219.428 438.607ZM402.285 438.607C392.058 438.608 383.75 446.915 383.75 457.143C383.75 467.37 392.058 475.678 402.285 475.679C412.513 475.679 420.821 467.37 420.821 457.143C420.821 446.915 412.512 438.607 402.285 438.607ZM146.035 439.107H168.116L168.176 438.941C175.715 417.797 195.732 402.536 219.428 402.536C243.124 402.536 263.142 417.797 270.681 438.941L270.739 439.107H350.974L351.033 438.941C354.107 430.321 359.215 422.752 365.882 416.739L365.964 416.665V292.321H146.035V439.107ZM402.035 402.536H402.285C425.981 402.536 445.999 417.797 453.538 438.941L453.597 439.107H475.679V383.75H402.035V402.536ZM402.035 347.679H460.015L459.756 347.29L447.565 329.004L447.491 328.893H402.035V347.679ZM164.571 0.25C255.183 0.25 328.893 73.9594 328.894 164.571C328.894 190.095 322.928 214.984 311.8 237.464H269.984C284.744 216.149 292.822 190.794 292.822 164.571C292.822 93.8619 235.281 36.3213 164.571 36.3213C93.8619 36.3215 36.3214 93.862 36.3213 164.571C36.3213 207.411 57.6302 246.099 91.1787 269.568V311.501C36.3688 284.143 0.25 227.821 0.25 164.571C0.25008 73.9596 73.9595 0.250208 164.571 0.25ZM164.571 55.1045C174.54 55.1047 182.606 63.1708 182.606 73.1396V76.6855L182.772 76.7451C203.917 84.284 219.178 104.301 219.178 127.997C219.178 137.966 211.112 146.033 201.143 146.033C191.174 146.033 183.106 137.966 183.106 127.997C183.106 117.77 174.798 109.461 164.571 109.461C154.344 109.461 146.035 117.77 146.035 127.997C146.035 138.224 154.344 146.533 164.571 146.533C194.683 146.533 219.178 171.028 219.178 201.14C219.178 215.134 213.739 227.786 205.048 237.461H124.094C115.403 227.786 109.964 215.134 109.964 201.14C109.964 191.171 118.03 183.105 127.999 183.104C137.968 183.104 146.035 191.171 146.035 201.14C146.035 211.367 154.344 219.676 164.571 219.676C174.798 219.676 183.106 211.367 183.106 201.14C183.106 190.913 174.798 182.605 164.571 182.604C134.459 182.604 109.964 158.109 109.964 127.997C109.964 104.301 125.225 84.284 146.369 76.7451L146.535 76.6855V73.1396C146.535 63.1707 154.602 55.1045 164.571 55.1045Z"
        fill={strokeColor}
        stroke={strokeColor}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const ContractsIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 511 512"
      fill={strokeColor}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M55.6406 0.5H367.231C397.68 0.500214 422.372 25.1974 422.372 55.6523V148.514C422.372 154.381 417.61 159.143 411.744 159.144C405.878 159.144 401.115 154.381 401.115 148.514V55.6523C401.115 36.9333 385.947 21.761 367.231 21.7607H55.6406C36.9251 21.761 21.7568 36.9333 21.7568 55.6523V456.348C21.7568 475.067 36.9251 490.239 55.6406 490.239H367.231C385.947 490.239 401.115 475.067 401.115 456.348V363.486C401.115 357.619 405.878 352.856 411.744 352.856C417.61 352.857 422.372 357.619 422.372 363.486V456.348C422.372 486.803 397.68 511.5 367.231 511.5H55.6406C25.1921 511.5 0.5 486.803 0.5 456.348V55.6523C0.5 25.1974 25.1921 0.500239 55.6406 0.5ZM119.597 378.938C123.625 378.938 127.303 381.212 129.099 384.815V384.816L148.283 423.183L148.422 423.459H186.366C192.233 423.459 196.994 428.222 196.994 434.09C196.994 439.958 192.233 444.72 186.366 444.72H141.854C137.825 444.72 134.149 442.445 132.353 438.842L132.352 438.841L120.044 414.231L119.597 413.338L119.149 414.231L106.842 438.841V438.842C105.046 442.445 101.369 444.72 97.3408 444.72H75.084C69.2176 444.72 64.4561 439.958 64.4561 434.09C64.4561 428.222 69.2175 423.459 75.084 423.459H90.7725L90.9102 423.183L110.096 384.816V384.815C111.892 381.212 115.569 378.938 119.597 378.938ZM464.573 154.417C473.298 154.417 481.662 157.892 487.822 164.054L487.823 164.055C489.943 166.169 492.146 168.37 494.348 170.572L500.864 177.099C507.025 183.26 510.5 191.626 510.5 200.353C510.5 209.08 507.036 217.445 500.865 223.606L500.864 223.607L308.881 415.629L308.88 415.63C305.274 419.247 300.868 421.966 296.023 423.578C288.278 426.16 272.832 431.31 259.322 435.815C252.568 438.068 246.297 440.159 241.715 441.688C239.424 442.451 237.555 443.075 236.259 443.507C235.611 443.723 235.106 443.892 234.763 444.006C234.591 444.063 234.46 444.106 234.372 444.136C234.328 444.15 234.295 444.162 234.272 444.169C234.261 444.173 234.253 444.176 234.247 444.178C234.244 444.179 234.243 444.179 234.241 444.18L234.239 444.181C230.423 445.446 226.214 444.456 223.366 441.607C220.518 438.759 219.53 434.549 220.795 430.732V430.73C220.795 430.729 220.796 430.727 220.797 430.725C220.799 430.719 220.802 430.71 220.806 430.699C220.813 430.677 220.824 430.644 220.839 430.6C220.868 430.512 220.912 430.38 220.969 430.209C221.083 429.866 221.252 429.361 221.468 428.713C221.9 427.417 222.523 425.547 223.287 423.256C224.815 418.673 226.905 412.401 229.157 405.645L241.393 368.937C243.004 364.09 245.723 359.684 249.34 356.077V356.076L441.324 164.054C447.484 157.881 455.848 154.417 464.573 154.417ZM257.526 387.754L248 416.337L247.684 417.285L248.633 416.969L277.21 407.441L277.977 407.186L277.405 406.613L258.354 387.559L257.781 386.986L257.526 387.754ZM419.707 215.737L268.519 366.956L268.165 367.31L268.519 367.663L297.296 396.446L297.65 396.8L298.004 396.446L449.191 245.229L449.545 244.875L449.191 244.521L420.414 215.737L420.061 215.384L419.707 215.737ZM100.157 289.875H255.952C261.819 289.875 266.58 294.638 266.58 300.506C266.58 306.374 261.819 311.136 255.952 311.136H100.157C94.2909 311.136 89.5295 306.374 89.5293 300.506C89.5293 294.638 94.2907 289.875 100.157 289.875ZM100.157 223.094H322.722C328.588 223.094 333.35 227.857 333.35 233.725C333.349 239.592 328.588 244.354 322.722 244.354H100.157C94.2909 244.354 89.5295 239.592 89.5293 233.725C89.5293 227.857 94.2907 223.094 100.157 223.094ZM464.573 175.678C461.491 175.678 458.526 176.91 456.352 179.085L435.442 199.999L435.089 200.353L435.442 200.706L464.22 229.489L464.573 229.844L464.927 229.489L485.837 208.575C488.011 206.4 489.243 203.435 489.243 200.353C489.243 197.27 488.011 194.305 485.837 192.13L472.794 179.085C470.62 176.91 467.655 175.678 464.573 175.678ZM100.157 156.302H322.722C328.588 156.302 333.35 161.065 333.35 166.933C333.35 172.8 328.588 177.562 322.722 177.562H100.157C94.2908 177.562 89.5293 172.801 89.5293 166.933C89.5293 161.065 94.2907 156.302 100.157 156.302ZM97.3457 89.542H319.909C325.776 89.542 330.538 94.304 330.538 100.172C330.538 106.04 325.776 110.803 319.909 110.803H97.3457C91.4792 110.803 86.7168 106.04 86.7168 100.172C86.7169 94.304 91.4792 89.542 97.3457 89.542Z"
        fill={strokeColor}
        stroke={strokeColor}
      />
    </svg>
  );
};

export const MediaGalleryIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 512 509"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_482_4381)">
        <path
          d="M36.15 0H475.854C485.875 0 494.842 4.1003 501.371 10.6341C507.9 17.1638 512 26.2769 512 36.1527V472.851C512 482.873 507.904 491.84 501.371 498.37C494.838 504.9 485.725 509.004 475.854 509.004H36.15C26.125 509.004 17.1625 504.904 10.6333 498.366C4.1 491.836 0 482.723 0 472.851V36.1485C0 26.1269 4.1 17.1638 10.6333 10.6341C17.1667 4.1003 26.2792 0 36.15 0ZM37.9042 368.04L185.45 226.779C191.371 221.308 200.638 221.916 205.954 227.842C206.108 227.992 206.108 228.146 206.258 228.146L337.338 383.232L357.388 259.89C358.754 251.989 366.196 246.522 374.096 247.893C377.133 248.347 379.867 249.868 381.992 251.844L473.95 348.451V44.8908C473.95 42.9157 473.188 41.2447 471.821 40.0321C470.608 38.8154 468.783 37.9028 466.963 37.9028H44.7375C42.7625 37.9028 41.0917 38.6612 39.8792 40.0321C38.6625 41.2447 37.75 43.0698 37.75 44.8908V368.04H37.9042ZM377.192 82.7811C391.625 82.7811 404.838 88.7065 414.254 98.1239C423.825 107.691 429.596 120.755 429.596 135.189C429.596 149.619 423.675 162.833 414.254 172.25C404.688 181.822 391.625 187.593 377.192 187.593C362.767 187.593 349.55 181.672 340.133 172.25C330.563 162.683 324.792 149.619 324.792 135.189C324.792 120.759 330.713 107.545 340.133 98.1239C349.704 88.5524 362.767 82.7811 377.192 82.7811Z"
          fill={strokeColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_482_4381">
          <rect width="512" height="509" fill={strokeColor} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ContractorsIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 385 513"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M355.434 42.601H281.466V37.16C281.466 32.742 278.052 29.16 273.842 29.16H232.841C226.343 11.861 210.422 0.25 192.25 0.25C174.077 0.25 158.156 11.859 151.659 29.159H110.658C106.448 29.159 103.034 32.741 103.034 37.159V42.6H29.0661C13.1766 42.6 0.25 56.164 0.25 72.837V277.425V482.012C0.249047 498.686 13.1766 512.25 29.0661 512.25H355.434C371.323 512.25 384.25 498.686 384.25 482.013V72.838C384.251 56.165 371.323 42.601 355.434 42.601ZM157.228 45.159H118.282V86.976H266.218V45.159H227.271C223.75 45.159 220.686 42.628 219.86 39.035C216.776 25.619 205.422 16.25 192.25 16.25C179.077 16.25 167.723 25.619 164.639 39.035C163.813 42.628 160.749 45.159 157.228 45.159ZM281.466 94.977C281.466 99.395 278.052 102.977 273.842 102.977L110.658 102.976C106.448 102.976 103.034 99.394 103.034 94.976V89.535H44.9795V465.315H339.52V89.536H281.466V94.977ZM355.435 496.25C362.916 496.25 369.003 489.864 369.003 482.013L369.002 72.838C369.002 64.988 362.916 58.601 355.434 58.601H281.466V73.535H347.145C351.355 73.535 354.769 77.117 354.769 81.535V473.315C354.769 477.733 351.355 481.315 347.145 481.315H37.3554C33.145 481.315 29.7314 477.733 29.7314 473.315V81.536C29.7314 77.118 33.145 73.536 37.3554 73.536H103.034V58.601H29.0661C21.585 58.601 15.4982 64.987 15.4982 72.838V277.426V482.013C15.4982 489.863 21.5841 496.25 29.0661 496.25H355.435Z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.9787 160.208C89.9787 166.348 91.9476 172.012 95.2536 176.55C81.6075 184.226 72.3023 199.336 72.3023 216.689C72.3023 221.107 75.716 224.689 79.9264 224.689H151.428C155.638 224.689 159.052 221.107 159.052 216.689C159.052 199.337 149.748 184.227 136.101 176.551C139.407 172.013 141.376 166.349 141.376 160.209C141.376 145.34 129.847 133.243 115.677 133.243C101.506 133.243 89.9787 145.339 89.9787 160.208ZM88.5997 208.688H142.754C139.422 196.289 128.545 187.174 115.677 187.174C102.808 187.174 91.9314 196.289 88.5997 208.688ZM126.128 160.208C126.128 154.161 121.439 149.242 115.677 149.242C109.914 149.242 105.226 154.161 105.226 160.208C105.226 166.255 109.914 171.175 115.677 171.175C121.439 171.175 126.128 166.255 126.128 160.208Z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M136.102 281.731C139.408 277.193 141.376 271.529 141.376 265.389C141.376 250.52 129.847 238.423 115.677 238.423C101.506 238.423 89.9778 250.52 89.9778 265.389C89.9778 271.529 91.9467 277.193 95.2527 281.731C81.6065 289.407 72.3013 304.517 72.3013 321.869C72.3013 326.287 75.715 329.869 79.9254 329.869H151.427C155.637 329.869 159.051 326.287 159.051 321.869C159.052 304.517 149.748 289.407 136.102 281.731ZM115.678 254.423C109.915 254.423 105.227 259.342 105.227 265.389C105.227 271.432 109.908 276.349 115.665 276.356H115.69C121.447 276.349 126.129 271.432 126.129 265.389C126.129 259.342 121.44 254.423 115.678 254.423ZM115.662 292.356C102.801 292.363 91.9305 301.474 88.5997 313.869H142.754C139.424 301.474 128.554 292.363 115.691 292.356H115.662Z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M136.102 386.912C139.408 382.374 141.377 376.71 141.377 370.57C141.377 355.701 129.848 343.603 115.678 343.603C101.507 343.603 89.9787 355.701 89.9787 370.57C89.9787 376.71 91.9476 382.374 95.2536 386.912C81.6075 394.588 72.3023 409.698 72.3023 427.051C72.3023 431.469 75.716 435.051 79.9264 435.051H151.428C155.638 435.051 159.052 431.469 159.052 427.051C159.052 409.699 149.748 394.589 136.102 386.912ZM115.678 359.603C109.915 359.603 105.227 364.523 105.227 370.57C105.227 376.617 109.915 381.537 115.678 381.537C121.44 381.537 126.129 376.617 126.129 370.57C126.129 364.523 121.44 359.603 115.678 359.603ZM115.677 397.537C102.808 397.537 91.9314 406.652 88.5997 419.051H142.754C139.422 406.651 128.545 397.537 115.677 397.537Z"
        fill={strokeColor}
      />
      <path
        d="M174.388 156.73C174.388 152.312 177.801 148.73 182.012 148.73H291.832C296.042 148.73 299.456 152.312 299.456 156.73C299.456 161.148 296.042 164.73 291.832 164.73H182.012C177.801 164.73 174.388 161.148 174.388 156.73Z"
        fill={strokeColor}
      />
      <path
        d="M174.388 201.199C174.388 196.781 177.801 193.199 182.012 193.199H291.832C296.042 193.199 299.456 196.781 299.456 201.199C299.456 205.617 296.042 209.199 291.832 209.199H182.012C177.801 209.199 174.388 205.617 174.388 201.199Z"
        fill={strokeColor}
      />
      <path
        d="M174.388 261.911C174.388 257.493 177.801 253.911 182.012 253.911H291.832C296.042 253.911 299.456 257.493 299.456 261.911C299.456 266.329 296.042 269.911 291.832 269.911H182.012C177.801 269.911 174.388 266.329 174.388 261.911Z"
        fill={strokeColor}
      />
      <path
        d="M174.388 306.381C174.388 301.963 177.801 298.381 182.012 298.381H291.832C296.042 298.381 299.456 301.963 299.456 306.381C299.456 310.799 296.042 314.381 291.832 314.381H182.012C177.801 314.381 174.388 310.799 174.388 306.381Z"
        fill={strokeColor}
      />
      <path
        d="M174.388 367.092C174.388 362.674 177.801 359.092 182.012 359.092H291.832C296.042 359.092 299.456 362.674 299.456 367.092C299.456 371.51 296.042 375.092 291.832 375.092H182.012C177.801 375.092 174.388 371.51 174.388 367.092Z"
        fill={strokeColor}
      />
      <path
        d="M174.388 411.562C174.388 407.144 177.801 403.562 182.012 403.562H291.832C296.042 403.562 299.456 407.144 299.456 411.562C299.456 415.98 296.042 419.562 291.832 419.562H182.012C177.801 419.562 174.388 415.979 174.388 411.562Z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M355.434 42.601H281.466V37.16C281.466 32.742 278.052 29.16 273.842 29.16H232.841C226.343 11.861 210.422 0.25 192.25 0.25C174.077 0.25 158.156 11.859 151.659 29.159H110.658C106.448 29.159 103.034 32.741 103.034 37.159V42.6H29.0661C13.1766 42.6 0.25 56.164 0.25 72.837V277.425V482.012C0.249047 498.686 13.1766 512.25 29.0661 512.25H355.434C371.323 512.25 384.25 498.686 384.25 482.013V72.838C384.251 56.165 371.323 42.601 355.434 42.601ZM157.228 45.159H118.282V86.976H266.218V45.159H227.271C223.75 45.159 220.686 42.628 219.86 39.035C216.776 25.619 205.422 16.25 192.25 16.25C179.077 16.25 167.723 25.619 164.639 39.035C163.813 42.628 160.749 45.159 157.228 45.159ZM281.466 94.977C281.466 99.395 278.052 102.977 273.842 102.977L110.658 102.976C106.448 102.976 103.034 99.394 103.034 94.976V89.535H44.9795V465.315H339.52V89.536H281.466V94.977ZM355.435 496.25C362.916 496.25 369.003 489.864 369.003 482.013L369.002 72.838C369.002 64.988 362.916 58.601 355.434 58.601H281.466V73.535H347.145C351.355 73.535 354.769 77.117 354.769 81.535V473.315C354.769 477.733 351.355 481.315 347.145 481.315H37.3554C33.145 481.315 29.7314 477.733 29.7314 473.315V81.536C29.7314 77.118 33.145 73.536 37.3554 73.536H103.034V58.601H29.0661C21.585 58.601 15.4982 64.987 15.4982 72.838V277.426V482.013C15.4982 489.863 21.5841 496.25 29.0661 496.25H355.435Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.9787 160.208C89.9787 166.348 91.9476 172.012 95.2536 176.55C81.6075 184.226 72.3023 199.336 72.3023 216.689C72.3023 221.107 75.716 224.689 79.9264 224.689H151.428C155.638 224.689 159.052 221.107 159.052 216.689C159.052 199.337 149.748 184.227 136.101 176.551C139.407 172.013 141.376 166.349 141.376 160.209C141.376 145.34 129.847 133.243 115.677 133.243C101.506 133.243 89.9787 145.339 89.9787 160.208ZM88.5997 208.688H142.754C139.422 196.289 128.545 187.174 115.677 187.174C102.808 187.174 91.9314 196.289 88.5997 208.688ZM126.128 160.208C126.128 154.161 121.439 149.242 115.677 149.242C109.914 149.242 105.226 154.161 105.226 160.208C105.226 166.255 109.914 171.175 115.677 171.175C121.439 171.175 126.128 166.255 126.128 160.208Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M136.102 281.731C139.408 277.193 141.376 271.529 141.376 265.389C141.376 250.52 129.847 238.423 115.677 238.423C101.506 238.423 89.9778 250.52 89.9778 265.389C89.9778 271.529 91.9467 277.193 95.2527 281.731C81.6065 289.407 72.3013 304.517 72.3013 321.869C72.3013 326.287 75.715 329.869 79.9254 329.869H151.427C155.637 329.869 159.051 326.287 159.051 321.869C159.052 304.517 149.748 289.407 136.102 281.731ZM115.678 254.423C109.915 254.423 105.227 259.342 105.227 265.389C105.227 271.432 109.908 276.349 115.665 276.356H115.69C121.447 276.349 126.129 271.432 126.129 265.389C126.129 259.342 121.44 254.423 115.678 254.423ZM115.662 292.356C102.801 292.363 91.9305 301.474 88.5997 313.869H142.754C139.424 301.474 128.554 292.363 115.691 292.356H115.662Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M136.102 386.912C139.408 382.374 141.377 376.71 141.377 370.57C141.377 355.701 129.848 343.603 115.678 343.603C101.507 343.603 89.9787 355.701 89.9787 370.57C89.9787 376.71 91.9476 382.374 95.2536 386.912C81.6075 394.588 72.3023 409.698 72.3023 427.051C72.3023 431.469 75.716 435.051 79.9264 435.051H151.428C155.638 435.051 159.052 431.469 159.052 427.051C159.052 409.699 149.748 394.589 136.102 386.912ZM115.678 359.603C109.915 359.603 105.227 364.523 105.227 370.57C105.227 376.617 109.915 381.537 115.678 381.537C121.44 381.537 126.129 376.617 126.129 370.57C126.129 364.523 121.44 359.603 115.678 359.603ZM115.677 397.537C102.808 397.537 91.9314 406.652 88.5997 419.051H142.754C139.422 406.651 128.545 397.537 115.677 397.537Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        d="M174.388 156.73C174.388 152.312 177.801 148.73 182.012 148.73H291.832C296.042 148.73 299.456 152.312 299.456 156.73C299.456 161.148 296.042 164.73 291.832 164.73H182.012C177.801 164.73 174.388 161.148 174.388 156.73Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        d="M174.388 201.199C174.388 196.781 177.801 193.199 182.012 193.199H291.832C296.042 193.199 299.456 196.781 299.456 201.199C299.456 205.617 296.042 209.199 291.832 209.199H182.012C177.801 209.199 174.388 205.617 174.388 201.199Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        d="M174.388 261.911C174.388 257.493 177.801 253.911 182.012 253.911H291.832C296.042 253.911 299.456 257.493 299.456 261.911C299.456 266.329 296.042 269.911 291.832 269.911H182.012C177.801 269.911 174.388 266.329 174.388 261.911Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        d="M174.388 306.381C174.388 301.963 177.801 298.381 182.012 298.381H291.832C296.042 298.381 299.456 301.963 299.456 306.381C299.456 310.799 296.042 314.381 291.832 314.381H182.012C177.801 314.381 174.388 310.799 174.388 306.381Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        d="M174.388 367.092C174.388 362.674 177.801 359.092 182.012 359.092H291.832C296.042 359.092 299.456 362.674 299.456 367.092C299.456 371.51 296.042 375.092 291.832 375.092H182.012C177.801 375.092 174.388 371.51 174.388 367.092Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
      <path
        d="M174.388 411.562C174.388 407.144 177.801 403.562 182.012 403.562H291.832C296.042 403.562 299.456 407.144 299.456 411.562C299.456 415.98 296.042 419.562 291.832 419.562H182.012C177.801 419.562 174.388 415.979 174.388 411.562Z"
        stroke={strokeColor}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export const PositionsIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 683 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M60.0293 0.5H622.971C655.802 0.5 682.5 26.7858 682.5 59.0771V452.923C682.5 485.214 655.802 511.5 622.971 511.5H60.0293C27.1977 511.5 0.5 485.214 0.5 452.923V59.0771L0.504883 58.3213C0.917485 26.3765 27.4542 0.5 60.0293 0.5ZM60.0293 38.8848C48.7273 38.8848 39.5195 47.9352 39.5195 59.0771V452.923C39.5195 464.065 48.7273 473.115 60.0293 473.115H622.971C634.273 473.115 643.48 464.065 643.48 452.923V59.0771C643.48 47.9352 634.273 38.8848 622.971 38.8848H60.0293ZM261.461 79.3105C360.493 79.3105 441.049 158.6 441.049 256.041C441.049 353.467 360.471 432.772 261.461 432.772C162.245 432.772 80.5391 353.52 80.5391 256.041C80.5393 158.428 162.371 79.3108 261.461 79.3105ZM261.461 314.618C224.86 314.618 191.876 333.814 174.14 364.468L173.919 364.849L174.27 365.116C198.344 383.448 228.617 394.388 261.461 394.388C294.257 394.388 324.465 383.273 348.405 364.676L348.751 364.406L348.53 364.028C330.734 333.629 297.888 314.618 261.461 314.618ZM501.573 354.963H582.946C593.728 354.963 602.456 363.564 602.456 374.155C602.456 384.747 593.728 393.348 582.946 393.348H501.573C490.791 393.347 482.063 384.747 482.063 374.155C482.064 363.564 490.791 354.963 501.573 354.963ZM261.461 117.695C183.227 117.696 119.559 179.745 119.559 256.041C119.559 285.715 129.195 313.233 145.568 335.786L145.981 336.355L146.384 335.777C160.497 315.479 179.733 299.494 201.995 289.222L202.614 288.936L202.155 288.432C189.582 274.583 181.922 256.332 181.922 236.349C181.922 193.199 217.596 158.08 261.461 158.08C305.326 158.08 341 193.199 341 236.349C341 256.332 333.341 274.583 320.769 288.432L320.311 288.936L320.929 289.222C342.906 299.364 361.945 315.065 376.006 334.994L376.414 335.571L376.823 334.995C392.702 312.591 402.029 285.37 402.029 256.041C402.029 179.749 338.963 117.695 261.461 117.695ZM501.573 276.166H582.946C593.728 276.166 602.456 284.767 602.456 295.358C602.456 305.95 593.728 314.551 582.946 314.551H501.573C490.791 314.551 482.063 305.95 482.063 295.358C482.064 284.767 490.791 276.166 501.573 276.166ZM261.461 196.465C239.126 196.465 220.942 214.349 220.941 236.349C220.941 258.349 239.126 276.233 261.461 276.233C283.796 276.233 301.98 258.349 301.98 236.349C301.98 214.349 283.796 196.465 261.461 196.465ZM501.573 197.438H582.946C593.728 197.438 602.456 206.038 602.456 216.63C602.456 227.222 593.728 235.822 582.946 235.822H501.573C490.791 235.822 482.063 227.222 482.063 216.63C482.064 206.038 490.791 197.438 501.573 197.438ZM501.573 118.627H582.946C593.728 118.627 602.456 127.228 602.456 137.819C602.456 148.411 593.728 157.012 582.946 157.012H501.573C490.791 157.012 482.063 148.411 482.063 137.819C482.064 127.228 490.791 118.627 501.573 118.627Z"
        fill={strokeColor}
        stroke={strokeColor}
      />
    </svg>
  );
};

export const SowPoTimesheetIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 542 542"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M287 477.203C295.284 477.203 302 470.488 302 462.203C302 453.919 295.284 447.203 287 447.203V462.203V477.203ZM352 272.062C352 280.346 358.716 287.062 367 287.062C375.284 287.062 382 280.346 382 272.062H367H352ZM143 96.6637C134.716 96.6637 128 103.379 128 111.664C128 119.948 134.716 126.664 143 126.664V111.664V96.6637ZM303 126.664C311.284 126.664 318 119.948 318 111.664C318 103.379 311.284 96.6637 303 96.6637V111.664V126.664ZM143 160.398C134.716 160.398 128 167.114 128 175.398C128 183.682 134.716 190.398 143 190.398V175.398V160.398ZM303 190.398C311.284 190.398 318 183.682 318 175.398C318 167.114 311.284 160.398 303 160.398V175.398V190.398ZM143 224.133C134.716 224.133 128 230.848 128 239.133C128 247.417 134.716 254.133 143 254.133V239.133V224.133ZM303 254.133C311.284 254.133 318 247.417 318 239.133C318 230.848 311.284 224.133 303 224.133V239.133V254.133ZM143 287.867C134.716 287.867 128 294.583 128 302.867C128 311.151 134.716 317.867 143 317.867V302.867V287.867ZM303 317.867C311.284 317.867 318 311.151 318 302.867C318 294.583 311.284 287.867 303 287.867V302.867V317.867ZM143 351.602C134.716 351.602 128 358.317 128 366.602C128 374.886 134.716 381.602 143 381.602V366.602V351.602ZM271 381.602C279.284 381.602 286 374.886 286 366.602C286 358.317 279.284 351.602 271 351.602V366.602V381.602ZM351 383.469C342.716 383.469 336 390.185 336 398.469C336 406.753 342.716 413.469 351 413.469V398.469V383.469ZM399 398.469V413.469C407.284 413.469 414 406.753 414 398.469H399ZM414 334.734C414 326.45 407.284 319.734 399 319.734C390.716 319.734 384 326.45 384 334.734H399H414ZM287 462.203V447.203H36.3333V462.203V477.203H287V462.203ZM36.3333 462.203V447.203C32.7763 447.203 30 444.349 30 440.959H15H0C0 461.035 16.3256 477.203 36.3333 477.203V462.203ZM15 440.959H30V36.2448H15H0V440.959H15ZM15 36.2448H30C30 32.8543 32.7763 30 36.3333 30V15V0C16.3255 0 0 16.1683 0 36.2448H15ZM36.3333 15V30H345.667V15V0H36.3333V15ZM345.667 15V30C349.224 30 352 32.8543 352 36.2448H367H382C382 16.1683 365.674 0 345.667 0V15ZM367 36.2448H352V272.062H367H382V36.2448H367ZM527 399.531H512C512 461.587 461.467 512 399 512V527V542C477.918 542 542 478.273 542 399.531H527ZM399 527V512C336.533 512 286 461.587 286 399.531H271H256C256 478.273 320.082 542 399 542V527ZM271 399.531H286C286 337.475 336.533 287.062 399 287.062V272.062V257.062C320.082 257.062 256 320.789 256 399.531H271ZM399 272.062V287.062C461.467 287.062 512 337.475 512 399.531H527H542C542 320.789 477.918 257.062 399 257.062V272.062ZM143 111.664V126.664H303V111.664V96.6637H143V111.664ZM143 175.398V190.398H303V175.398V160.398H143V175.398ZM143 239.133V254.133H303V239.133V224.133H143V239.133ZM95 111.664H80C80 112.12 79.6109 112.597 79 112.597V127.597V142.597C96.0617 142.597 110 128.806 110 111.664H95ZM79 127.597V112.597C78.3892 112.597 78 112.12 78 111.664H63H48C48 128.806 61.9383 142.597 79 142.597V127.597ZM63 111.664H78C78 111.207 78.3892 110.73 79 110.73V95.7301V80.7301C61.9383 80.7301 48 94.5211 48 111.664H63ZM79 95.7301V110.73C79.6109 110.73 80 111.207 80 111.664H95H110C110 94.5211 96.0617 80.7301 79 80.7301V95.7301ZM143 302.867V317.867H303V302.867V287.867H143V302.867ZM95 175.398H80C80 175.855 79.6109 176.332 79 176.332V191.332V206.332C96.0617 206.332 110 192.541 110 175.398H95ZM79 191.332V176.332C78.3892 176.332 78 175.855 78 175.398H63H48C48 192.541 61.9383 206.332 79 206.332V191.332ZM63 175.398H78C78 174.942 78.3892 174.465 79 174.465V159.465V144.465C61.9383 144.465 48 158.256 48 175.398H63ZM79 159.465V174.465C79.6109 174.465 80 174.942 80 175.398H95H110C110 158.256 96.0617 144.465 79 144.465V159.465ZM95 239.133H80C80 239.589 79.6109 240.066 79 240.066V255.066V270.066C96.0617 270.066 110 256.275 110 239.133H95ZM79 255.066V240.066C78.3891 240.066 78 239.589 78 239.133H63H48C48 256.275 61.9384 270.066 79 270.066V255.066ZM63 239.133H78C78 238.676 78.3892 238.199 79 238.199V223.199V208.199C61.9383 208.199 48 221.99 48 239.133H63ZM79 223.199V238.199C79.6109 238.199 80 238.676 80 239.133H95H110C110 221.99 96.0617 208.199 79 208.199V223.199ZM95 302.867H80C80 303.324 79.6109 303.801 79 303.801V318.801V333.801C96.0617 333.801 110 320.01 110 302.867H95ZM79 318.801V303.801C78.3892 303.801 78 303.324 78 302.867H63H48C48 320.01 61.9383 333.801 79 333.801V318.801ZM63 302.867H78C78 302.411 78.3892 301.934 79 301.934V286.934V271.934C61.9383 271.934 48 285.725 48 302.867H63ZM79 286.934V301.934C79.6109 301.934 80 302.411 80 302.867H95H110C110 285.725 96.0617 271.934 79 271.934V286.934ZM143 366.602V381.602H271V366.602V351.602H143V366.602ZM95 366.602H80C80 367.058 79.6109 367.535 79 367.535V382.535V397.535C96.0617 397.535 110 383.744 110 366.602H95ZM79 382.535V367.535C78.3891 367.535 78 367.058 78 366.602H63H48C48 383.744 61.9384 397.535 79 397.535V382.535ZM63 366.602H78C78 366.145 78.3892 365.668 79 365.668V350.668V335.668C61.9383 335.668 48 349.459 48 366.602H63ZM79 350.668V365.668C79.6109 365.668 80 366.145 80 366.602H95H110C110 349.459 96.0617 335.668 79 335.668V350.668ZM351 398.469V413.469H399V398.469V383.469H351V398.469ZM399 398.469H414V334.734H399H384V398.469H399Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export const ReportsIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 468 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.524 0.5H411.017C442.163 0.5 467.517 25.8432 467.5 56.9922V377.519C467.5 408.755 442.145 434.165 411 434.165H390.079V454.991C390.079 486.157 364.708 511.5 333.527 511.5H57.0342C25.8708 511.5 0.500213 486.157 0.5 454.991V134.396C0.500223 103.247 25.8538 77.8869 57.0342 77.8867H77.835V56.9746C77.8351 25.8444 103.273 0.500125 134.524 0.5ZM57.0342 107.814C42.3535 107.815 30.4238 119.756 30.4238 134.413V455.008C30.4238 469.666 42.3713 481.59 57.0342 481.59H333.527C348.208 481.59 360.138 469.665 360.138 455.008V134.413C360.138 119.739 348.208 107.815 333.527 107.814H57.0342ZM134.524 30.4268C119.778 30.4269 107.776 42.349 107.776 56.9922V77.9043H333.527C364.708 77.9045 390.079 103.247 390.079 134.413V404.255H411C425.649 404.255 437.559 392.275 437.559 377.535L437.576 56.9922C437.576 42.3349 425.663 30.4268 411.017 30.4268H134.524ZM289.953 336.941C296.174 331.521 305.655 332.153 311.077 338.403C316.5 344.655 315.818 354.099 309.58 359.52L271.248 392.782C268.52 395.143 265.027 396.44 261.434 396.44C260.852 396.44 260.305 396.407 259.739 396.341H259.736C255.561 395.875 251.785 393.681 249.324 390.29V390.289L234.249 369.603C229.392 362.918 230.856 353.557 237.541 348.703C244.229 343.864 253.595 345.329 258.451 351.995L263.608 359.074L263.929 359.515L264.34 359.157L289.952 336.941H289.953ZM90.7959 349.906H191.921C200.188 349.906 206.892 356.607 206.892 364.87C206.891 373.133 200.188 379.834 191.921 379.834H90.7959C82.5288 379.834 75.8253 373.133 75.8252 364.87C75.8252 356.607 82.5287 349.906 90.7959 349.906ZM90.7959 268.927H299.768C308.035 268.927 314.738 275.628 314.738 283.891C314.738 292.154 308.035 298.854 299.768 298.854H90.7959C82.5287 298.854 75.8252 292.154 75.8252 283.891C75.8252 275.628 82.5287 268.927 90.7959 268.927ZM158.659 157.854H231.903C240.17 157.854 246.874 164.555 246.874 172.817C246.874 181.08 240.171 187.781 231.903 187.781H158.659C150.392 187.781 143.688 181.08 143.688 172.817C143.689 164.555 150.392 157.855 158.659 157.854Z"
        fill={strokeColor}
        stroke={strokeColor}
      />
    </svg>
  );
};

export const UsersIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 542 499"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M349.784 435.224C372.179 441.676 395.384 444.94 418.704 444.916C456.208 444.97 493.224 436.484 526.903 420.111C527.899 396.758 521.196 373.719 507.81 354.486C494.424 335.253 475.085 320.875 452.724 313.531C430.362 306.188 406.198 306.278 383.894 313.789C361.589 321.3 342.36 335.823 329.121 355.155M349.784 435.224V435.145C349.784 406.146 342.275 378.866 329.121 355.155M349.784 435.224V437.985C299.254 468.186 241.365 484.098 182.379 484C121.177 484 63.914 467.194 15.0263 437.985L15 435.145C14.9799 398.263 27.3299 362.423 50.1031 333.275C72.8764 304.128 104.777 283.331 140.777 274.164C176.776 264.997 214.826 267.98 248.928 282.645C283.029 297.309 311.243 322.82 329.121 355.155M271.017 102.937C271.017 126.26 261.681 148.627 245.063 165.119C228.445 181.61 205.906 190.875 182.405 190.875C158.904 190.875 136.365 181.61 119.747 165.119C103.129 148.627 93.7927 126.26 93.7927 102.937C93.7927 79.615 103.129 57.2477 119.747 40.7563C136.365 24.2648 158.904 15 182.405 15C205.906 15 228.445 24.2648 245.063 40.7563C261.681 57.2477 271.017 79.615 271.017 102.937ZM487.625 161.562C487.625 179.702 480.364 197.099 467.439 209.925C454.513 222.752 436.983 229.958 418.704 229.958C400.425 229.958 382.895 222.752 369.97 209.925C357.045 197.099 349.784 179.702 349.784 161.562C349.784 143.423 357.045 126.026 369.97 113.199C382.895 100.373 400.425 93.1666 418.704 93.1666C436.983 93.1666 454.513 100.373 467.439 113.199C480.364 126.026 487.625 143.423 487.625 161.562Z"
        stroke={strokeColor}
        strokeWidth="30"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 498 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M355.646 470.556C361.252 471.717 367.057 472.329 373.004 472.329C378.95 472.329 384.755 471.717 390.359 470.557V494.14C390.359 503.723 382.584 511.5 373.003 511.5C363.422 511.5 355.646 503.723 355.646 494.14V470.556ZM244.04 282.978C253.62 282.978 261.396 290.779 261.396 300.338C261.396 309.921 253.62 317.699 244.04 317.699C173.265 317.699 110.276 334.428 71.3105 361.031C49.5095 375.871 35.2129 393.433 35.2129 413.454V448.008C35.2129 449.405 35.7682 450.723 36.7646 451.72C37.7359 452.691 39.0757 453.27 40.4746 453.271H244.041C253.62 453.247 261.396 461.048 261.396 470.607C261.396 480.19 253.62 487.968 244.038 487.991H40.4746C30.2017 487.991 20.3472 484.018 12.9209 476.97L12.21 476.278C4.70904 468.776 0.5 458.591 0.5 448.008V413.454C0.500011 383.502 18.6514 354.894 51.7324 332.328C95.1019 302.752 165.017 282.978 244.04 282.978ZM301.668 433.771C308.083 443.535 316.447 451.906 326.203 458.329L309.508 475.016L309.507 475.017C302.75 481.797 291.735 481.797 284.979 475.017L284.978 475.015L284.664 474.695C278.199 467.914 278.304 457.133 284.978 450.48V450.479L301.668 433.771ZM461.031 450.479L461.032 450.48C467.812 457.239 467.812 468.256 461.032 475.015L461.03 475.017C454.274 481.797 443.259 481.798 436.502 475.017L436.501 475.016L419.807 458.332C429.565 451.911 437.931 443.542 444.35 433.78L461.031 450.479ZM354.646 469.317C344.962 467.162 335.903 463.337 327.786 458.161L338.643 447.312H338.644C344.528 441.407 345.566 432.482 341.761 425.51C349.026 431.414 357.986 435.309 367.792 436.336C360.195 438.589 354.647 445.637 354.646 453.941V469.317ZM408.406 421.722C415.101 415.391 425.618 415.395 432.308 421.734L432.628 422.047L443.627 433.058C437.231 442.837 428.86 451.21 419.084 457.609L408.073 446.605C401.424 439.931 401.318 429.176 407.757 422.372C407.975 422.157 408.192 421.94 408.406 421.722ZM313.381 422.047C320.051 415.398 330.798 415.289 337.602 421.722C337.818 421.942 338.036 422.16 338.257 422.377C344.691 429.181 344.584 439.933 337.936 446.605L326.927 457.606C317.152 451.205 308.783 442.83 302.391 433.047L313.381 422.047ZM422.354 392.152C424.58 399.773 431.637 405.344 439.954 405.344H455.323C453.17 415.024 449.35 424.081 444.182 432.197L433.335 421.339H433.334C427.429 415.453 418.504 414.414 411.532 418.222C417.44 410.946 421.333 401.972 422.354 392.152ZM323.654 392.151C324.674 401.972 328.568 410.946 334.476 418.222C327.504 414.414 318.58 415.453 312.675 421.339H312.674L301.837 432.188C296.674 424.074 292.859 415.021 290.707 405.344H306.03C314.367 405.344 321.427 399.773 323.654 392.151ZM439.954 369.623H455.541C456.715 375.225 457.335 381.031 457.335 386.979C457.335 392.931 456.715 398.739 455.54 404.344H439.954C430.397 404.344 422.598 396.562 422.621 386.98L422.622 386.979C422.622 377.397 430.398 369.623 439.954 369.623ZM265.865 369.623H289.468C288.308 375.228 287.697 381.033 287.697 386.979C287.697 392.928 288.308 398.736 289.469 404.344H265.865C256.285 404.344 248.509 396.566 248.509 386.983C248.509 377.401 256.285 369.623 265.865 369.623ZM312.674 352.605L312.675 352.606C318.59 358.502 327.534 359.534 334.511 355.703C328.579 362.987 324.671 371.981 323.652 381.828C321.424 374.2 314.375 368.623 306.03 368.623H290.706C292.859 358.94 296.676 349.881 301.845 341.765L312.674 352.605ZM444.173 341.755C449.347 349.874 453.17 358.936 455.325 368.623H439.954C431.629 368.623 424.583 374.2 422.355 381.828C421.337 371.981 417.428 362.987 411.497 355.703C418.474 359.534 427.419 358.503 433.334 352.606L433.335 352.605L444.173 341.755ZM337.935 327.338V327.339C344.692 334.121 344.693 345.115 337.937 351.897C331.156 358.657 320.162 358.657 313.381 351.897L302.399 340.905C308.795 331.125 317.168 322.753 326.946 316.356L337.935 327.338ZM419.064 316.354C428.845 322.748 437.219 331.117 443.618 340.895L432.628 351.897C425.847 358.657 414.853 358.657 408.072 351.897C401.316 345.115 401.316 334.12 408.073 327.338L419.064 316.354ZM354.646 320.016C354.647 328.344 360.227 335.407 367.857 337.64C358.014 338.657 349.019 342.561 341.732 348.486C345.571 341.507 344.542 332.553 338.644 326.633L338.643 326.632L327.806 315.802C335.917 310.635 344.97 306.817 354.646 304.664V320.016ZM284.979 298.929C291.735 292.147 302.75 292.147 309.507 298.929L309.508 298.93L326.223 315.634C316.463 322.053 308.095 330.42 301.677 340.182L284.978 323.465V323.464L284.664 323.145C278.199 316.363 278.304 305.582 284.978 298.93L284.979 298.929ZM436.502 298.929C443.259 292.147 454.274 292.147 461.03 298.929L461.032 298.93C467.812 305.688 467.812 316.706 461.032 323.464L461.031 323.465L444.341 340.172C437.919 330.413 429.55 322.048 419.788 315.631L436.501 298.93L436.502 298.929ZM373.003 262.457C382.583 262.457 390.359 270.235 390.359 279.817V303.425C384.755 302.265 378.95 301.655 373.004 301.655C367.057 301.655 361.252 302.265 355.646 303.426V279.817C355.647 270.235 363.422 262.457 373.003 262.457ZM230.15 0.5C302.158 0.5 360.599 58.9538 360.599 130.977C360.598 202.999 302.157 261.452 230.15 261.452C158.143 261.452 99.7024 202.999 99.7021 130.977C99.7021 58.9538 158.143 0.500044 230.15 0.5ZM230.15 35.2207C177.304 35.2207 134.415 78.1196 134.415 130.977C134.415 183.833 177.305 226.731 230.15 226.731C282.996 226.731 325.886 183.833 325.886 130.977C325.886 78.1195 282.996 35.2207 230.15 35.2207ZM355.646 453.941C355.647 444.648 362.996 437.018 372.207 436.601C372.472 436.605 372.738 436.607 373.004 436.607C373.259 436.607 373.514 436.604 373.769 436.601C382.995 437.024 390.359 444.639 390.359 453.941V469.534C384.757 470.709 378.952 471.329 373.004 471.329C367.055 471.329 361.249 470.709 355.646 469.533V453.941ZM391.359 453.941C391.359 445.628 385.8 438.592 378.192 436.338C388.008 435.314 396.977 431.417 404.248 425.508C400.514 432.348 401.444 441.068 407.036 446.973L407.366 447.312L418.225 458.164C410.106 463.339 401.045 467.163 391.359 469.318V453.941ZM288.697 386.979C288.697 381.031 289.317 375.225 290.49 369.623H306.03C315.611 369.623 323.386 377.397 323.387 386.979V386.981C323.41 396.562 315.612 404.344 306.03 404.344H290.491C289.317 398.739 288.697 392.931 288.697 386.979ZM458.335 386.979C458.335 381.033 457.724 375.228 456.563 369.623H480.144C489.724 369.623 497.5 377.401 497.5 386.983C497.5 396.566 489.724 404.344 480.144 404.344H456.562C457.724 398.736 458.335 392.928 458.335 386.979ZM355.646 304.448C361.249 303.274 367.055 302.655 373.004 302.655C378.952 302.655 384.757 303.273 390.359 304.447V319.991C390.359 329.574 382.585 337.352 373.003 337.375C363.423 337.374 355.647 329.575 355.646 320.016V304.448ZM391.359 304.663C401.037 306.815 410.091 310.633 418.205 315.799L407.366 326.632V326.633C401.467 332.553 400.438 341.507 404.277 348.487C396.985 342.557 387.982 338.651 378.129 337.638C385.77 335.404 391.359 328.348 391.359 319.991V304.663Z"
        fill={strokeColor}
        stroke={strokeColor}
      />
    </svg>
  );
};

export const GenerateQRCodeIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.333 341.833C32.8329 341.833 42.167 351.167 42.167 362.667V469.833H149.333C160.833 469.833 170.167 479.167 170.167 490.667C170.167 502.167 160.833 511.5 149.333 511.5H21.333C9.83341 511.5 0.500168 502.167 0.5 490.667V362.667C0.5 351.167 9.8333 341.833 21.333 341.833ZM490.667 341.833C502.167 341.833 511.5 351.167 511.5 362.667V490.667C511.5 502.167 502.167 511.5 490.667 511.5H362.667C351.167 511.5 341.833 502.167 341.833 490.667C341.833 479.167 351.167 469.833 362.667 469.833H469.833V362.667C469.833 351.167 479.167 341.833 490.667 341.833ZM106.667 277.833H213.333C224.844 277.833 234.167 287.156 234.167 298.667V405.333C234.167 416.844 224.844 426.167 213.333 426.167H106.667C95.1565 426.167 85.833 416.844 85.833 405.333V298.667C85.833 287.156 95.1565 277.833 106.667 277.833ZM426.339 384.542V426.208H384.672V384.542H426.339ZM340.661 384.542V426.208H298.995V384.542H340.661ZM127.5 384.5H192.5V319.5H127.5V384.5ZM383.5 341.833V383.5H341.833V341.833H383.5ZM426.167 299.208V340.875H384.5V299.208H426.167ZM340.833 299.208V340.875H299.167V299.208H340.833ZM107.198 85.875H213.864C225.375 85.875 234.698 95.1976 234.698 106.708V213.375C234.698 224.885 225.375 234.208 213.864 234.208H107.198C95.6878 234.208 86.3643 224.885 86.3643 213.375V106.708C86.3644 95.1976 95.6878 85.875 107.198 85.875ZM298.495 85.875H405.161C416.672 85.875 425.995 95.1976 425.995 106.708V213.375C425.995 224.885 416.672 234.208 405.161 234.208H298.495C286.985 234.208 277.661 224.885 277.661 213.375V106.708C277.661 95.1976 286.985 85.875 298.495 85.875ZM128.031 192.542H193.031V127.542H128.031V192.542ZM319.328 192.542H384.328V127.542H319.328V192.542ZM21.333 0.5H149.333C160.833 0.5 170.167 9.8333 170.167 21.333C170.167 32.8329 160.833 42.167 149.333 42.167H42.167V149.333C42.167 160.833 32.8329 170.167 21.333 170.167C9.8333 170.167 0.5 160.833 0.5 149.333V21.333C0.50017 9.83341 9.83341 0.50017 21.333 0.5ZM362.667 0.5H490.667C502.167 0.500168 511.5 9.83341 511.5 21.333V149.333C511.5 160.833 502.167 170.167 490.667 170.167C479.167 170.167 469.833 160.833 469.833 149.333V42.167H362.667C351.167 42.167 341.833 32.8329 341.833 21.333C341.833 9.8333 351.167 0.5 362.667 0.5Z"
        fill={strokeColor}
        stroke={strokeColor}
      />
    </svg>
  );
};

export const MessagesIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 13C19 13.5304 18.7893 14.0391 18.4142 14.4142C18.0391 14.7893 17.5304 15 17 15H5L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V13Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RateListIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 24 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.8478 19.0482C22.1779 15.0496 20.2634 11.3644 17.377 8.51727C16.7451 7.90247 16.4298 7.59569 15.7319 7.31213C15.0339 7.02734 14.4338 7.02734 13.2348 7.02734H10.5996C9.4006 7.02734 8.80048 7.02734 8.10257 7.31213C7.40589 7.59569 7.08811 7.90247 6.45742 8.51727C3.57103 11.3644 1.65655 15.0496 0.986637 19.0482C0.391402 22.6391 3.7037 25.3611 7.40467 25.3611H16.4298C20.132 25.3611 23.4455 22.6391 22.8466 19.0482"
        stroke={strokeColor}
        strokeWidth="1.83337"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9057 14.2618C13.6417 13.2852 12.296 12.4052 10.6814 13.064C9.06685 13.7227 8.8114 15.8409 11.2522 16.067C12.3571 16.1685 13.0758 15.9485 13.7346 16.5706C14.3946 17.1915 14.5169 18.921 12.8314 19.3866C11.1483 19.8523 9.47997 19.1251 9.29907 18.0911M11.724 11.9065V12.8366M11.724 19.5296V20.4634M6.12 3.90197C5.867 3.5353 5.50155 3.03662 6.2569 2.92417C7.03302 2.80684 7.83849 3.33729 8.62806 3.32751C9.34063 3.31651 9.70364 2.99995 10.0948 2.54772C10.5054 2.07226 11.141 0.916016 11.9171 0.916016C12.6933 0.916016 13.3288 2.07226 13.7395 2.54772C14.1306 2.99995 14.4936 3.31774 15.2062 3.32629C15.9958 3.33851 16.8012 2.80684 17.5774 2.92295C18.3327 3.03662 17.9673 3.53407 17.7143 3.90075L16.5751 5.56179C16.0862 6.27069 15.843 6.62514 15.3321 6.82681C14.8212 7.02848 14.1624 7.02726 12.8436 7.02726H10.9907C9.67064 7.02726 9.01185 7.02726 8.50217 6.82681C7.99249 6.62636 7.74804 6.26947 7.25914 5.56056L6.12 3.90197Z"
        stroke={strokeColor}
        strokeWidth="1.83337"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConfigurationIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 542 542"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M356.545 355.91C454.167 354.327 527 282.054 527 185.455C527 112.111 502.722 136.388 478.299 161.104C454.167 184.968 405.246 234.156 405.246 234.156L307.844 136.754C307.844 136.754 357.032 87.833 380.896 63.7014C405.612 39.2777 405.612 15 356.545 15C259.946 15 187.381 87.833 186.09 185.455C187.113 209.221 186.09 258.507 186.09 258.507C140.189 304.7 80.4079 364.506 39.9857 404.611C-31.4106 476.3 65.7 573.411 137.389 502.014C177.567 461.543 237.543 401.568 283.493 355.91C283.493 355.91 332.779 354.887 356.545 355.91Z"
        stroke={strokeColor}
        strokeWidth="30"
      />
    </svg>
  );
};

export const BigSearchMenuIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="10.5" cy="10.5" r="6.75" stroke={strokeColor} strokeWidth="1.8" />
      <path
        d="M15.5 15.5L21 21"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M7.75 10.5H13.25M10.5 7.75V13.25"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

/** Sidebar icon for the Deposit Invoices tracker (finance request 2026-09-10, item 11). */
export const DepositsMenuIcon = ({
  size = 24,
  width,
  height,
  strokeColor = "#ffffff",
  ...props
}) => {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="3" y="5" width="18" height="14" rx="2" stroke={strokeColor} strokeWidth="1.8" />
      <path d="M3 9.5H21" stroke={strokeColor} strokeWidth="1.8" />
      <path
        d="M12 12.5C10.9 12.5 10.2 13 10.2 13.6C10.2 14.9 13.8 14.3 13.8 15.6C13.8 16.2 13.1 16.7 12 16.7M12 12.5C12.8 12.5 13.4 12.8 13.7 13.2M12 12.5V11.6M12 16.7C11.2 16.7 10.6 16.4 10.3 16M12 16.7V17.6"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
